export default function PhilosophySection() {
  return (
    <section
      className="relative w-full bg-gradient-to-b from-background-900 via-background-900 to-background-950 py-20 md:py-28 px-6 md:px-12 lg:px-20 overflow-hidden"
      aria-label="Engineering philosophy"
    >
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="mb-4">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/20 text-secondary-300 font-label text-xs font-medium tracking-wide uppercase">
            <span className="w-3 h-px bg-secondary-400/60" />
            Philosophy
          </span>
        </div>

        <div className="max-w-2xl">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
            Built on Principles of Technical Excellence
          </h2>
          <p className="mt-5 text-background-50/70 text-base md:text-lg leading-relaxed font-body">
            We emphasize continuous innovation, improvement of development
            workflows, and adoption of up-to-date engineering standards to
            deliver reliable and future-ready solutions. We actively explore
            new technologies and evolve our internal processes to maintain
            high technical excellence.
          </p>
        </div>

        <div className="mt-16 md:mt-20 flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
          <div className="flex-shrink-0 w-full lg:w-1/3">
            <div className="aspect-square rounded-2xl bg-background-800/60 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-secondary-100/10 to-transparent" />
              <div className="absolute top-1/4 left-1/4 w-1/2 h-px bg-background-600/40" />
              <div className="absolute top-1/3 left-1/3 w-1/3 h-px bg-background-600/30" />
              <div className="absolute bottom-1/3 right-1/3 w-2/5 h-px bg-background-600/30" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="w-20 h-20 rounded-full border border-background-600/30" />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full border border-background-600/20" />
              </div>
            </div>
          </div>

          <div className="flex-1">
            <span className="font-heading text-8xl md:text-9xl lg:text-[10rem] font-bold text-background-50/10 leading-none select-none">
              MMXXVI
            </span>
            <p className="mt-4 text-background-50/60 text-sm md:text-base leading-relaxed max-w-md font-body">
              Founded with a clear vision: to bring disciplined engineering
              practices and modern software craftsmanship to every project we
              undertake. Our commitment to quality shapes every decision we make.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <div className="px-5 py-2.5 rounded-full border border-background-600/30 text-background-50/50 font-label text-sm">
                Clean Architecture
              </div>
              <div className="px-5 py-2.5 rounded-full border border-background-600/30 text-background-50/50 font-label text-sm">
                Continuous Innovation
              </div>
              <div className="px-5 py-2.5 rounded-full border border-background-600/30 text-background-50/50 font-label text-sm">
                Engineering Standards
              </div>
              <div className="px-5 py-2.5 rounded-full border border-background-600/30 text-background-50/50 font-label text-sm">
                Long-Term Quality
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-accent-900/5 to-transparent pointer-events-none" />
    </section>
  );
}